import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import usePermission from "../../../config/permissions";
import SkeletonLoader from "../../../components/Skeletonloader";
import { CustomModel, isEditable } from "../../../components/CustomFunctions";
import { AllAssociateLetter, AssociatedLetters } from "../../../components/SiteManagement/ProjectDetailsCrudButtons";
import { DocumentModel } from "../../../components/SiteManagement/ProjectDetailsCrudButtons";
import { UpdateTrackRecordDetails } from "../../../components/SiteManagement/ProjectDetailsCrudButtons";
import { DeleteTrackAndLetterDetails } from "../../../components/SiteManagement/ProjectDetailsCrudButtons";
import { Modal } from 'react-bootstrap';
import * as XLSX from "xlsx";
import AllAssociatedLetters from "../../../components/SiteManagement/AllAssociatedLetters";
import { Users, CheckCircle, XCircle, Filter, ChevronUp, ChevronDown, X } from "lucide-react";
// const SortingTable = forwardRef(({
//     error,
//     buffer,
//     siteRole,
//     projectID,
//     filteredData,
//     rowRefs,
//     currentPage,
//     itemsPerPage,
//     calculateDaysBetweenDates,
//     formattedDateLong,
//     getLetters,
//     projectList,
//     letterData,
//     extendedLetterTypeOptions,

// }, ref) => {

//     const [tableData, setTableData] = useState([]);
//     const [sortingState, setSortingState] = useState({
//         project: 0,
//         AE: 0,
//         letter: 0,
//         tat: 0,
//         due: 0,
//         letterDate: 0,
//         letterAdded: 0,
//         deadline: 0,
//         letterFrom: 0,
//         OtherletterFrom: 0,
//         letterTo: 0,
//         OtherletterTo: 0,
//         contractor: 0
//     });

//     const [visibleSection, setVisibleSection] = useState({
//         project: true,
//         letterNo: true,
//         AE: true,
//         subject: true,
//         tat: true,
//         due: true,
//         letterDetails: true,
//         letterDate: true,
//         letterAdded: true,
//         deadline: true,
//         letterFrom: true,
//         letterTo: true,
//         contractor: true,
//         OtherletterTo: true,
//         OtherletterFrom: true,
//     });

//     const [showTableSection, setShowTableSection] = useState(false);

//     const cycleSortingState = (key) => {
//         setSortingState(prevState => ({
//             ...prevState,
//             [key]: (prevState[key] + 1) % 3
//         }));
//     };




//     const updateTableData = (sortingState) => {
//         let updatedData = [...filteredData];

//         // Sort by project_short_name
//         if (sortingState.project === 1 || sortingState.project === 2) {
//             updatedData.sort((a, b) => {
//                 const valA = a.project_short_name?.toLowerCase() || "";
//                 const valB = b.project_short_name?.toLowerCase() || "";
//                 if (valA < valB) return sortingState.project === 1 ? -1 : 1;
//                 if (valA > valB) return sortingState.project === 1 ? 1 : -1;
//                 return 0;
//             });
//         }
//         // Sort by ae
//         if (sortingState.AE === 1 || sortingState.AE === 2) {
//             updatedData.sort((a, b) => {
//                 const valA = a.authority_engineer_name?.toLowerCase() || "";
//                 const valB = b.authority_engineer_name?.toLowerCase() || "";
//                 if (valA < valB) return sortingState.AE === 1 ? -1 : 1;
//                 if (valA > valB) return sortingState.AE === 1 ? 1 : -1;
//                 return 0;
//             });
//         }

//         // Sort by letter_num
//         if (sortingState.letter === 1 || sortingState.letter === 2) {
//             updatedData.sort((a, b) => {
//                 const valA = a.letter_num?.toLowerCase() || "";
//                 const valB = b.letter_num?.toLowerCase() || "";
//                 if (valA < valB) return sortingState.letter === 1 ? -1 : 1;
//                 if (valA > valB) return sortingState.letter === 1 ? 1 : -1;
//                 return 0;
//             });
//         }

//         // Sort by tat_duration
//         if (sortingState.tat === 1 || sortingState.tat === 2) {
//             updatedData.sort((a, b) => {
//                 const valA = a.tat_duration !== null ? parseFloat(a.tat_duration) : null;
//                 const valB = b.tat_duration !== null ? parseFloat(b.tat_duration) : null;

//                 if (valA === null && valB === null) return 0;
//                 if (valA === null) return sortingState.tat === 1 ? 1 : -1;
//                 if (valB === null) return sortingState.tat === 1 ? -1 : 1;

//                 return sortingState.tat === 1 ? valA - valB : valB - valA;
//             });
//         }

//         // Sort by due (based on days until end_date)
//         if (sortingState.due === 1 || sortingState.due === 2) {
//             updatedData.sort((a, b) => {
//                 const daysA = a.end_date ? calculateDaysBetweenDates(a.end_date) : null;
//                 const daysB = b.end_date ? calculateDaysBetweenDates(b.end_date) : null;

//                 if (daysA === null && daysB === null) return 0;
//                 if (daysA === null) return sortingState.due === 1 ? 1 : -1;
//                 if (daysB === null) return sortingState.due === 1 ? -1 : 1;

//                 return sortingState.due === 1 ? daysA - daysB : daysB - daysA;
//             });
//         }

//         // Sort by letter_date
//         if (sortingState.letterDate === 1 || sortingState.letterDate === 2) {
//             updatedData.sort((a, b) => {
//                 const dateA = a.letter_date ? new Date(a.letter_date) : null;
//                 const dateB = b.letter_date ? new Date(b.letter_date) : null;

//                 if (!dateA && !dateB) return 0;
//                 if (!dateA) return sortingState.letterDate === 1 ? 1 : -1;
//                 if (!dateB) return sortingState.letterDate === 1 ? -1 : 1;

//                 return sortingState.letterDate === 1
//                     ? dateB - dateA
//                     : dateA - dateB;
//             });
//         }

//         // Sort by created_at
//         if (sortingState.letterAdded === 1 || sortingState.letterAdded === 2) {
//             updatedData.sort((a, b) => {
//                 const dateA = a.created_at ? new Date(a.created_at) : null;
//                 const dateB = b.created_at ? new Date(b.created_at) : null;

//                 if (!dateA && !dateB) return 0;
//                 if (!dateA) return sortingState.letterAdded === 1 ? 1 : -1;
//                 if (!dateB) return sortingState.letterAdded === 1 ? -1 : 1;

//                 return sortingState.letterAdded === 1
//                     ? dateB - dateA  // Latest to oldest
//                     : dateA - dateB; // Oldest to latest
//             });
//         }

//         // Sort by end_date as date (latest to oldest or oldest to latest)
//         if (sortingState.deadline === 1 || sortingState.deadline === 2) {
//             updatedData.sort((a, b) => {
//                 const dateA = a.end_date ? new Date(a.end_date) : null;
//                 const dateB = b.end_date ? new Date(b.end_date) : null;

//                 if (!dateA && !dateB) return 0;
//                 if (!dateA) return sortingState.deadline === 1 ? 1 : -1;
//                 if (!dateB) return sortingState.deadline === 1 ? -1 : 1;

//                 return sortingState.deadline === 1
//                     ? dateB - dateA  // Latest to oldest
//                     : dateA - dateB; // Oldest to latest
//             });
//         }

//         // Sort by letter_from
//         if (sortingState.letterFrom === 1 || sortingState.letterFrom === 2) {
//             updatedData.sort((a, b) => {
//                 const valA = a.letter_from?.toLowerCase() || "";
//                 const valB = b.letter_from?.toLowerCase() || "";
//                 if (valA < valB) return sortingState.letterFrom === 1 ? -1 : 1;
//                 if (valA > valB) return sortingState.letterFrom === 1 ? 1 : -1;
//                 return 0;
//             });
//         }

//         // Sort by letter_to
//         if (sortingState.letterTo === 1 || sortingState.letterTo === 2) {
//             updatedData.sort((a, b) => {
//                 const valA = a.letter_to?.toLowerCase() || "";
//                 const valB = b.letter_to?.toLowerCase() || "";
//                 if (valA < valB) return sortingState.letterTo === 1 ? -1 : 1;
//                 if (valA > valB) return sortingState.letterTo === 1 ? 1 : -1;
//                 return 0;
//             });
//         }
//         if (sortingState.OtherletterFrom === 1 || sortingState.OtherletterFrom === 2) {
//             updatedData.sort((a, b) => {
//                 const valA = a.other_letter_from?.toLowerCase() || "";
//                 const valB = b.other_letter_from?.toLowerCase() || "";
//                 if (valA < valB) return sortingState.OtherletterFrom === 1 ? -1 : 1;
//                 if (valA > valB) return sortingState.OtherletterFrom === 1 ? 1 : -1;
//                 return 0;
//             });
//         }

//         // Sort by letter_to
//         if (sortingState.OtherletterTo === 1 || sortingState.OtherletterTo === 2) {
//             updatedData.sort((a, b) => {
//                 const valA = a.other_letter_to?.toLowerCase() || "";
//                 const valB = b.other_letter_to?.toLowerCase() || "";
//                 if (valA < valB) return sortingState.OtherletterTo === 1 ? -1 : 1;
//                 if (valA > valB) return sortingState.OtherletterTo === 1 ? 1 : -1;
//                 return 0;
//             });
//         }

//         // Sort by contractor
//         if (sortingState.contractor === 1 || sortingState.contractor === 2) {
//             updatedData.sort((a, b) => {
//                 const valA = a.contractorname?.toLowerCase() || "";
//                 const valB = b.contractorname?.toLowerCase() || "";
//                 if (valA < valB) return sortingState.contractor === 1 ? -1 : 1;
//                 if (valA > valB) return sortingState.contractor === 1 ? 1 : -1;
//                 return 0;
//             });
//         }

//         setTableData(updatedData);
//     };

//     const handleCheckboxChange = (e) => {
//         const { name, checked } = e.target;
//         setVisibleSection(prev => ({
//             ...prev,
//             [name]: checked
//         }));
//     };



//     useEffect(() => {
//         updateTableData(sortingState);
//     }, [sortingState]);

//     useEffect(() => {
//         setTableData(filteredData);
//     }, [filteredData]);

//     const exportToExcel = () => {
//         console.log(visibleSection, 'visible section')
//         const exportData = tableData.map((item, index) => {
//             const daysUntilDeadline = item.end_date ? calculateDaysBetweenDates(item.end_date) : "-";
//             const isOverdue = item.end_date && new Date(item.end_date) < new Date();
//             const isDueSoon = item.end_date && new Date(item.end_date) <= new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);


//             let rowData = {
//                 "S.no.": (currentPage - 1) * itemsPerPage + index + 1
//             };


//             if (!projectID && visibleSection.project) {
//                 rowData["Project"] = `${item?.project_pr_code}-${item.project_short_name}`;
//             }
//             if (visibleSection.AE) {
//                 rowData["Authority Engineer"] = item.authority_engineer_name || "-";
//             }

//             if (visibleSection.letterNo) {
//                 rowData["Letter No."] = item.letter_num || "-";
//             }


//             if (visibleSection.subject) {
//                 rowData["Subject"] = item.subject || "-";
//             }

//             if (visibleSection.tat) {
//                 rowData["TAT Duration"] = item.tat_duration || "-";
//             }

//             if (visibleSection.due) {
//                 rowData["Due Date"] = daysUntilDeadline;
//             }

//             if (visibleSection.letterDetails) {
//                 rowData["Coordinator Name"] = item.com_operators_name || "-";
//                 rowData["Exchange Type"] = item.letterExchange || "-";
//                 rowData["Letter Type"] = item.lettertype || "-";
//                 rowData["Other Type Name"] = item.other_type_name || "-";
//                 rowData["Status"] = item.status || "-";
//                 rowData["Remarks"] = item.remarks || "-";
//                 rowData["Time Bound"] = item.is_timebound || "-";
//                 rowData["Associated Letters"] = item.associated_letters.length > 0 ? "Yes" : "No";
//             }

//             if (visibleSection.letterFrom) {
//                 rowData["Letter From"] = item.letter_from || "-";
//             }

//             if (visibleSection.OtherletterTo) {
//                 rowData["Other Letter To"] = item.other_letter_to || "-";
//             }
//             if (visibleSection.OtherletterFrom) {
//                 rowData["Other Letter From"] = item.other_letter_from || "-";
//             }
//             if (visibleSection.letterTo) {
//                 rowData["Letter To"] = item.letter_to || "-";
//             }

//             if (visibleSection.contractor) {
//                 rowData["Contractor"] = item.contractorname || "-";
//             }

//             if (visibleSection.letterDate) {
//                 rowData["Letter Date"] = item.letter_date ? formattedDateLong(item.letter_date) : "-";
//             }

//             if (visibleSection.letterAdded) {
//                 rowData["Letter Added"] = item.created_at ? formattedDateLong(item.created_at) : "-";
//             }

//             if (visibleSection.deadline) {
//                 rowData["Deadline"] = item.end_date ? formattedDateLong(item.end_date) : "-";
//                 rowData["Deadline Status"] = isOverdue ? "Overdue" : isDueSoon ? "Due Soon" : "On Track";
//             }

//             return rowData;
//         });

//         // Create a worksheet
//         const ws = XLSX.utils.json_to_sheet(exportData);

//         // Create a workbook
//         const wb = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(wb, ws, "Letter Tracking");

//         // Generate Excel file and trigger download
//         XLSX.writeFile(wb, `Letter_Tracking_${new Date().toISOString().slice(0, 10)}.xlsx`);
//     };

//     useImperativeHandle(ref, () => ({
//         exportToExcel,
//     }));

//     return (
//         <>
//             <label style={{ marginLeft: 'auto', color: '#2576bc', fontSize: '14px', fontWeight: 500, cursor: 'pointer' }} onClick={() => setShowTableSection(true)}>Customize Table Headings</label>
//             <Modal show={showTableSection} onHide={() => setShowTableSection(false)}>
//                 <Modal.Header closeButton>
//                     <Modal.Title>Customize Table Headings</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div style={{ display: 'flex', flexDirection: 'column' }}>
//                         <div className="table-section-checkbox-field">
//                             <input type="checkbox"
//                                 name="project"
//                                 checked={visibleSection.project}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="project">Project Name</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input type="checkbox"
//                                 name="AE"
//                                 checked={visibleSection.AE}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="AE">Authority Engineer</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="letterNo"
//                                 checked={visibleSection.letterNo}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="letterNo">Letter No.</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="subject"
//                                 checked={visibleSection.subject}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="subject">Subject</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="letterFrom"
//                                 checked={visibleSection.letterFrom}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="letterFrom">Letter From</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="letterTo"
//                                 checked={visibleSection.letterTo}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="letterTo">Letter To</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="OtherletterFrom"
//                                 checked={visibleSection.OtherletterFrom}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="OtherletterFrom">Other Letter From</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="OtherletterTo"
//                                 checked={visibleSection.OtherletterTo}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="OtherletterTo">Other Letter To</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="contractor"
//                                 checked={visibleSection.contractor}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="contractor">Contractor</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="tat"
//                                 checked={visibleSection.tat}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="tat">Letter Tat</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="due"
//                                 checked={visibleSection.due}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="due">Due Date</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="letterDetails"
//                                 checked={visibleSection.letterDetails}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="letterDetails">Letter Details</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="letterDate"
//                                 checked={visibleSection.letterDate}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="letterDate">Letter Date</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="letterAdded"
//                                 checked={visibleSection.letterAdded}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="letterAdded">Letter Add</label>
//                         </div>
//                         <div className="table-section-checkbox-field">
//                             <input
//                                 type="checkbox"
//                                 name="deadline"
//                                 checked={visibleSection.deadline}
//                                 onChange={handleCheckboxChange}
//                             />
//                             <label htmlFor="deadline">Deadline</label>
//                         </div>
//                     </div>
//                 </Modal.Body>
//             </Modal>
//             <div className="table-css-white-background " style={{ padding: "0px 0px" }}>
//                 <div className="table-box scroll-container-table">
//                     <div>
//                         <table className="table-css">
//                             <thead className="table-heading" style={{ zIndex: 10 }}>

//                                 <tr className="custom-table-head-tr">
//                                     <th className="table-heading-text text-left-sr">S.no.</th>
//                                     {siteRole === "BD" ? (
//                                         ""
//                                     ) : (
//                                         <>
//                                             {siteRole !== "ViewAccess" &&
//                                                 <th className="table-heading-text text-right">Edit Letter</th>
//                                             }
//                                         </>
//                                     )}
//                                     {!projectID ? (
//                                         visibleSection.project && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('project')}>Project <span>{sortingState.project === 1 ? '▲' : sortingState.project === 2 ? '▼' : ''}</span></th>
//                                     ) : (
//                                         ""
//                                     )}

//                                     <th className="table-heading-text text-right">Letter Attachment</th>

//                                     {visibleSection.AE && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('AE')}>Authority Engineer<span>{sortingState.AE === 1 ? '▲' : sortingState.AE === 2 ? '▼' : ''}</span></th>}
//                                     {visibleSection.letterNo && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('letter')}>Letter No. <span>{sortingState.letter === 1 ? '▲' : sortingState.letter === 2 ? '▼' : ''}</span></th>}
//                                     {visibleSection.subject && <th className="table-heading-text text-center">Subject</th>}
//                                     {visibleSection.letterFrom && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('letterFrom')}>Letter From <span>{sortingState.letterFrom === 1 ? '▲' : sortingState.letterFrom === 2 ? '▼' : ''}</span></th>}
//                                     {visibleSection.OtherletterFrom && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('OtherletterFrom')}>Other Letter From <span>{sortingState.OtherletterFrom === 1 ? '▲' : sortingState.OtherletterFrom === 2 ? '▼' : ''}</span></th>}
//                                     {visibleSection.letterTo && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('letterTo')}>Letter To <span>{sortingState.letterTo === 1 ? '▲' : sortingState.letterTo === 2 ? '▼' : ''}</span></th>}
//                                     {visibleSection.OtherletterTo && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('OtherletterTo')}>Other Letter To <span>{sortingState.OtherletterTo === 1 ? '▲' : sortingState.OtherletterTo === 2 ? '▼' : ''}</span></th>}
//                                     {visibleSection.contractor && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('contractor')}>Contractor <span>{sortingState.contractor === 1 ? '▲' : sortingState.contractor === 2 ? '▼' : ''}</span></th>}
//                                     {visibleSection.letterDetails && <th className="table-heading-text text-center hover-heading">Time Bound</th>}
//                                     {visibleSection.tat && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('tat')}>TAT Duration <span>{sortingState.tat === 1 ? '▲' : sortingState.tat === 2 ? '▼' : ''}</span></th>}
//                                     {visibleSection.due && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('due')}>Due Days <span>{sortingState.due === 1 ? '▲' : sortingState.due === 2 ? '▼' : ''}</span></th>}
//                                     {visibleSection.letterDetails && (
//                                         <>
//                                             <th className="table-heading-text text-center">Coordinator Name</th>
//                                             <th className="table-heading-text text-center">Exchange Type</th>
//                                             <th className="table-heading-text text-center">Letter Type</th>
//                                             <th className="table-heading-text text-center">Other Letter Type</th>
//                                             <th className="table-heading-text text-center">Status</th>
//                                             <th className="table-heading-text text-center">Remarks</th>
//                                             <th className="table-heading-text text-center">Associated Letter</th>
//                                         </>
//                                     )}
//                                     {visibleSection.letterDate && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('letterDate')}>Letter Date <span>{sortingState.letterDate === 1 ? '▲' : sortingState.letterDate === 2 ? '▼' : ''}</span></th>}
//                                     {visibleSection.letterAdded && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('letterAdded')}>Letter Add <span>{sortingState.letterAdded === 1 ? '▲' : sortingState.letterAdded === 2 ? '▼' : ''}</span></th>}
//                                     {visibleSection.deadline && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('deadline')}>Deadline <span>{sortingState.deadline === 1 ? '▲' : sortingState.deadline === 2 ? '▼' : ''}</span></th>}

//                                     {siteRole === "BD" || siteRole === "ViewAccess" ? (
//                                         ""
//                                     ) : (
//                                         <>
//                                             <th className="table-heading-text text-center">Action</th>
//                                         </>
//                                     )}
//                                 </tr>
//                             </thead>
//                             {buffer ? (
//                                 <div>
//                                     <SkeletonLoader animationfirst={true} />
//                                     <div className="spinner-bgdatil"></div>


//                                 </div>
//                             ) : //  <div className={`${p_id ? "spinner-smalll" : "spinner-bgdatil"}`}></div>

//                                 error ? (
//                                     <p>Error fetching data: {error.message}</p>
//                                 ) : (
//                                     <tbody>
//                                         {Array.isArray(tableData) &&
//                                             tableData.map((i, index) => (
//                                                 <React.Fragment key={index}>
//                                                     <tr
//                                                         className={`custom-table-head-td ${i.status === "pending" ? "font-bold" : ""}`}
//                                                         style={{ backgroundColor: i.status === "pending" ? "rgba(253, 224, 71, 0.1)" : "", fontWeight: i.status === "pending" ? "bold" : "" }}
//                                                         ref={(el) => (rowRefs.current[index] = el)}
//                                                     >
//                                                         <td className="table-body text-left-sr">
//                                                             {(currentPage - 1) * itemsPerPage + index + 1}.
//                                                         </td>
//                                                         {siteRole === "BD" ? (
//                                                             ""
//                                                         ) : (
//                                                             <>
//                                                                 {siteRole !== "ViewAccess" &&
//                                                                     <td className="table-body ">
//                                                                         <UpdateTrackRecordDetails
//                                                                             i={i}
//                                                                             getProjects={getLetters}
//                                                                             projectList={projectList}
//                                                                             projectId={projectID}
//                                                                             letterType={i.lettertype}
//                                                                             workperformedby={i.workperformedby}
//                                                                             associatedletters={i.associated_letters}
//                                                                             letterData={letterData}
//                                                                             LetterTypeOptions={extendedLetterTypeOptions}
//                                                                         />

//                                                                     </td>
//                                                                 }
//                                                             </>
//                                                         )}


//                                                         {!projectID ? (
//                                                             visibleSection.project && <td className="table-body text-center">
//                                                                 <div style={{ whiteSpace: "normal" }}>
//                                                                     {i?.project_pr_code}-{i.project_short_name}
//                                                                 </div>
//                                                             </td>
//                                                         ) : (
//                                                             ""
//                                                         )}

//                                                         <td className="table-body ">
//                                                             <div className="flex-row justify-center">

//                                                                 <DocumentModel letterData={tableData} letterrecord={i.id} title="Letter Attacments" />
//                                                             </div>
//                                                         </td>
//                                                         {visibleSection.AE && <td className="table-body form-text-transformation-uppercase">
//                                                             <div
//                                                                 style={{
//                                                                     wordBreak: "break-word", // Ensures words break at the container width
//                                                                     whiteSpace: "normal", // Allows wrapping to the next line
//                                                                 }}
//                                                             >
//                                                                 {i.authority_engineer_name}
//                                                             </div>
//                                                         </td>}
//                                                         {visibleSection.letterNo && <td className="table-body form-text-transformation-uppercase">
//                                                             <div
//                                                                 style={{
//                                                                     wordBreak: "break-word", // Ensures words break at the container width
//                                                                     whiteSpace: "normal", // Allows wrapping to the next line
//                                                                 }}
//                                                             >
//                                                                 {i.letter_num}
//                                                             </div>
//                                                         </td>}

//                                                         {visibleSection.subject && <td className="table-body text-center">
//                                                             <div style={{ width: "120px", whiteSpace: "normal" }}>
//                                                                 {i.subject ? i.subject : <p className="">-</p>}
//                                                             </div>
//                                                         </td>}

//                                                         {visibleSection.letterFrom && <td className="table-body text-center">
//                                                             <div style={{ whiteSpace: "normal" }}>
//                                                                 {i.letter_from ? i.letter_from : <p className="">-</p>}
//                                                             </div>
//                                                         </td>}
//                                                         {visibleSection.OtherletterFrom && <td className="table-body text-center">
//                                                             <div style={{ whiteSpace: "normal" }}>
//                                                                 {i.other_letter_from ? i.other_letter_from : <p className="">-</p>}
//                                                             </div>
//                                                         </td>}

//                                                         {visibleSection.letterTo && <td className="table-body text-center">
//                                                             <div style={{ whiteSpace: "normal" }}>
//                                                                 {i.letter_to ? i.letter_to : <p className="">-</p>}
//                                                             </div>
//                                                         </td>}
//                                                         {visibleSection.OtherletterTo && <td className="table-body text-center">
//                                                             <div style={{ whiteSpace: "normal" }}>
//                                                                 {i.other_letter_to ? i.other_letter_to : <p className="">-</p>}
//                                                             </div>
//                                                         </td>}

//                                                         {visibleSection.contractor && <td className="table-body text-center">
//                                                             <div style={{ whiteSpace: "normal" }}>
//                                                                 {i.contractorname ? i.contractorname : <p className="">-</p>}
//                                                             </div>
//                                                         </td>}

//                                                         {visibleSection.letterDetails && <td className="table-body text-center">
//                                                             <div style={{ whiteSpace: "normal" }}>
//                                                                 {i.is_timebound === true ? "Yes" : "No"}
//                                                             </div>
//                                                         </td>}
//                                                         {visibleSection.tat && <td className="table-body text-center">
//                                                             <div style={{ whiteSpace: "normal" }}>
//                                                                 {i.tat_duration ? i.tat_duration : <p className="">-</p>}
//                                                             </div>
//                                                         </td>}
//                                                         {visibleSection.due && <td className="table-body text-center">
//                                                             <div style={{ whiteSpace: "normal" }}>
//                                                                 {i.end_date ? calculateDaysBetweenDates(i.end_date) : "-"}
//                                                             </div>
//                                                         </td>}

//                                                         {visibleSection.letterDetails && (
//                                                             <>
//                                                                 <td className="table-body text-center">
//                                                                     {i.com_operators_name.map((name, index) => (
//                                                                         <tr key={index}>
//                                                                             {i.com_operators_name.length > 1 &&
//                                                                                 <td className="padding-bottom-5px" style={{ paddingRight: "5px" }}>{index + 1}.</td>
//                                                                             }
//                                                                             <td className="padding-bottom-5px text-start">{name}</td>
//                                                                         </tr>
//                                                                     ))}
//                                                                 </td>

//                                                                 <td className="table-body text-center">
//                                                                     <div style={{ whiteSpace: "normal" }}>
//                                                                         {i.letterExchange ? i.letterExchange : "-"}
//                                                                     </div>
//                                                                 </td>
//                                                                 <td className="table-body text-center">
//                                                                     <div style={{ whiteSpace: "normal" }}>
//                                                                         {i.lettertype}
//                                                                     </div>
//                                                                 </td>
//                                                                 <td className="table-body text-center">
//                                                                     <div style={{ whiteSpace: "normal" }}>
//                                                                         {i.other_type_name ? i.other_type_name : "-"}
//                                                                     </div>
//                                                                 </td>
//                                                                 <td className="table-body text-center">
//                                                                     <div style={{ whiteSpace: "normal" }}>
//                                                                         {i.status ? i.status : "-"}
//                                                                     </div>
//                                                                 </td>
//                                                                 <td className="table-body text-center">
//                                                                     <div style={{ whiteSpace: "normal" }}>
//                                                                         {i.remarks ? (
//                                                                             <CustomModel
//                                                                                 i={i.remarks}
//                                                                                 usedFor="nestedTable"
//                                                                                 title="Remarks"
//                                                                             />
//                                                                         ) : (
//                                                                             "-"
//                                                                         )}
//                                                                     </div>
//                                                                 </td>
//                                                                 <td className="table-body text-center ali">
//                                                                     <div style={{ whiteSpace: "normal" }}>
//                                                                         <AllAssociatedLetters id={i.id} project={i.project} workperformedby={i.workperformedby} lettertype={i.lettertype} />
//                                                                     </div>
//                                                                 </td>
//                                                             </>
//                                                         )}

//                                                         {visibleSection.letterDate && <td className="table-body text-center">{i.letter_date !== null ? formattedDateLong(i.letter_date) : "-"}</td>}
//                                                         {visibleSection.letterAdded && <td className="table-body text-center">{i.created_at !== null ? formattedDateLong(i.created_at) : "-"}</td>}
//                                                         {visibleSection.deadline && <td
//                                                             className="table-body text-start text-center"
//                                                             style={{
//                                                                 color:
//                                                                     i.end_date && new Date(i.end_date) < new Date()
//                                                                         ? "red"
//                                                                         : i.end_date && new Date(i.end_date) <= new Date(Date.now() + 3 * 24 * 60 * 60 * 1000)
//                                                                             ? "orange"
//                                                                             : "inherit"
//                                                             }}
//                                                         >
//                                                             {i.end_date !== null ? formattedDateLong(i.end_date) : "-"}
//                                                         </td>}

//                                                         {siteRole === "BD" ? (
//                                                             ""
//                                                         ) : (
//                                                             <>
//                                                                 <td className="table-body " >
//                                                                     <div className="flex-row justify-center" style={{ alignItems: "center" }}>

//                                                                         {siteRole === "Admin" || siteRole === "AdminCIPL" ? (
//                                                                             <DeleteTrackAndLetterDetails
//                                                                                 i={i}
//                                                                                 getLetterDetail={getLetters}
//                                                                             />
//                                                                         ) :
//                                                                             <>
//                                                                                 {((new Date() - new Date(i.created_at)) / (1000 * 60 * 60) < 24) && siteRole === "SiteManagement" ?
//                                                                                     <DeleteTrackAndLetterDetails
//                                                                                         i={i}
//                                                                                         getLetterDetail={getLetters}
//                                                                                     /> : <span className="required">Access Denied</span>
//                                                                                 }

//                                                                             </>

//                                                                         }
//                                                                     </div>
//                                                                 </td>
//                                                             </>
//                                                         )}
//                                                     </tr>
//                                                 </React.Fragment>
//                                             ))}
//                                     </tbody>
//                                 )}
//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );

// });


const SortingTable = forwardRef(({
    error,
    buffer,
    siteRole,
    projectID,
    filteredData,
    rowRefs,
    currentPage,
    itemsPerPage,
    calculateDaysBetweenDates,
    formattedDateLong,
    getLetters,
    projectList,
    letterData,
    extendedLetterTypeOptions,

}, ref) => {

    const [tableData, setTableData] = useState([]);
    const [sortingState, setSortingState] = useState({
        project: 0,
        AE: 0,
        letter: 0,
        tat: 0,
        due: 0,
        letterDate: 0,
        letterAdded: 0,
        deadline: 0,
        letterFrom: 0,
        OtherletterFrom: 0,
        letterTo: 0,
        OtherletterTo: 0,
        contractor: 0
    });

    const [visibleSection, setVisibleSection] = useState({
        project: true,
        letterNo: true,
        AE: true,
        subject: true,
        tat: true,
        due: true,
        letterDetails: true,
        letterDate: true,
        letterAdded: true,
        deadline: true,
        letterFrom: true,
        letterTo: true,
        contractor: true,
        OtherletterTo: true,
        OtherletterFrom: true,
    });

    const [showTableSection, setShowTableSection] = useState(false);

    // --- new: stats/filter toggle state (same pattern as SiteEmployeeExcelData) ---
    const [showFilters, setShowFilters] = useState(true);
    const [activeStatFilter, setActiveStatFilter] = useState("all"); // 'all' | 'pending' | 'other'

    const cycleSortingState = (key) => {
        setSortingState(prevState => ({
            ...prevState,
            [key]: (prevState[key] + 1) % 3
        }));
    };




    const updateTableData = (sortingState) => {
        let updatedData = [...filteredData];

        // Sort by project_short_name
        if (sortingState.project === 1 || sortingState.project === 2) {
            updatedData.sort((a, b) => {
                const valA = a.project_short_name?.toLowerCase() || "";
                const valB = b.project_short_name?.toLowerCase() || "";
                if (valA < valB) return sortingState.project === 1 ? -1 : 1;
                if (valA > valB) return sortingState.project === 1 ? 1 : -1;
                return 0;
            });
        }
        // Sort by ae
        if (sortingState.AE === 1 || sortingState.AE === 2) {
            updatedData.sort((a, b) => {
                const valA = a.authority_engineer_name?.toLowerCase() || "";
                const valB = b.authority_engineer_name?.toLowerCase() || "";
                if (valA < valB) return sortingState.AE === 1 ? -1 : 1;
                if (valA > valB) return sortingState.AE === 1 ? 1 : -1;
                return 0;
            });
        }

        // Sort by letter_num
        if (sortingState.letter === 1 || sortingState.letter === 2) {
            updatedData.sort((a, b) => {
                const valA = a.letter_num?.toLowerCase() || "";
                const valB = b.letter_num?.toLowerCase() || "";
                if (valA < valB) return sortingState.letter === 1 ? -1 : 1;
                if (valA > valB) return sortingState.letter === 1 ? 1 : -1;
                return 0;
            });
        }

        // Sort by tat_duration
        if (sortingState.tat === 1 || sortingState.tat === 2) {
            updatedData.sort((a, b) => {
                const valA = a.tat_duration !== null ? parseFloat(a.tat_duration) : null;
                const valB = b.tat_duration !== null ? parseFloat(b.tat_duration) : null;

                if (valA === null && valB === null) return 0;
                if (valA === null) return sortingState.tat === 1 ? 1 : -1;
                if (valB === null) return sortingState.tat === 1 ? -1 : 1;

                return sortingState.tat === 1 ? valA - valB : valB - valA;
            });
        }

        // Sort by due (based on days until end_date)
        if (sortingState.due === 1 || sortingState.due === 2) {
            updatedData.sort((a, b) => {
                const daysA = a.end_date ? calculateDaysBetweenDates(a.end_date) : null;
                const daysB = b.end_date ? calculateDaysBetweenDates(b.end_date) : null;

                if (daysA === null && daysB === null) return 0;
                if (daysA === null) return sortingState.due === 1 ? 1 : -1;
                if (daysB === null) return sortingState.due === 1 ? -1 : 1;

                return sortingState.due === 1 ? daysA - daysB : daysB - daysA;
            });
        }

        // Sort by letter_date
        if (sortingState.letterDate === 1 || sortingState.letterDate === 2) {
            updatedData.sort((a, b) => {
                const dateA = a.letter_date ? new Date(a.letter_date) : null;
                const dateB = b.letter_date ? new Date(b.letter_date) : null;

                if (!dateA && !dateB) return 0;
                if (!dateA) return sortingState.letterDate === 1 ? 1 : -1;
                if (!dateB) return sortingState.letterDate === 1 ? -1 : 1;

                return sortingState.letterDate === 1
                    ? dateB - dateA
                    : dateA - dateB;
            });
        }

        // Sort by created_at
        if (sortingState.letterAdded === 1 || sortingState.letterAdded === 2) {
            updatedData.sort((a, b) => {
                const dateA = a.created_at ? new Date(a.created_at) : null;
                const dateB = b.created_at ? new Date(b.created_at) : null;

                if (!dateA && !dateB) return 0;
                if (!dateA) return sortingState.letterAdded === 1 ? 1 : -1;
                if (!dateB) return sortingState.letterAdded === 1 ? -1 : 1;

                return sortingState.letterAdded === 1
                    ? dateB - dateA  // Latest to oldest
                    : dateA - dateB; // Oldest to latest
            });
        }

        // Sort by end_date as date (latest to oldest or oldest to latest)
        if (sortingState.deadline === 1 || sortingState.deadline === 2) {
            updatedData.sort((a, b) => {
                const dateA = a.end_date ? new Date(a.end_date) : null;
                const dateB = b.end_date ? new Date(b.end_date) : null;

                if (!dateA && !dateB) return 0;
                if (!dateA) return sortingState.deadline === 1 ? 1 : -1;
                if (!dateB) return sortingState.deadline === 1 ? -1 : 1;

                return sortingState.deadline === 1
                    ? dateB - dateA  // Latest to oldest
                    : dateA - dateB; // Oldest to latest
            });
        }

        // Sort by letter_from
        if (sortingState.letterFrom === 1 || sortingState.letterFrom === 2) {
            updatedData.sort((a, b) => {
                const valA = a.letter_from?.toLowerCase() || "";
                const valB = b.letter_from?.toLowerCase() || "";
                if (valA < valB) return sortingState.letterFrom === 1 ? -1 : 1;
                if (valA > valB) return sortingState.letterFrom === 1 ? 1 : -1;
                return 0;
            });
        }

        // Sort by letter_to
        if (sortingState.letterTo === 1 || sortingState.letterTo === 2) {
            updatedData.sort((a, b) => {
                const valA = a.letter_to?.toLowerCase() || "";
                const valB = b.letter_to?.toLowerCase() || "";
                if (valA < valB) return sortingState.letterTo === 1 ? -1 : 1;
                if (valA > valB) return sortingState.letterTo === 1 ? 1 : -1;
                return 0;
            });
        }
        if (sortingState.OtherletterFrom === 1 || sortingState.OtherletterFrom === 2) {
            updatedData.sort((a, b) => {
                const valA = a.other_letter_from?.toLowerCase() || "";
                const valB = b.other_letter_from?.toLowerCase() || "";
                if (valA < valB) return sortingState.OtherletterFrom === 1 ? -1 : 1;
                if (valA > valB) return sortingState.OtherletterFrom === 1 ? 1 : -1;
                return 0;
            });
        }

        // Sort by letter_to
        if (sortingState.OtherletterTo === 1 || sortingState.OtherletterTo === 2) {
            updatedData.sort((a, b) => {
                const valA = a.other_letter_to?.toLowerCase() || "";
                const valB = b.other_letter_to?.toLowerCase() || "";
                if (valA < valB) return sortingState.OtherletterTo === 1 ? -1 : 1;
                if (valA > valB) return sortingState.OtherletterTo === 1 ? 1 : -1;
                return 0;
            });
        }

        // Sort by contractor
        if (sortingState.contractor === 1 || sortingState.contractor === 2) {
            updatedData.sort((a, b) => {
                const valA = a.contractorname?.toLowerCase() || "";
                const valB = b.contractorname?.toLowerCase() || "";
                if (valA < valB) return sortingState.contractor === 1 ? -1 : 1;
                if (valA > valB) return sortingState.contractor === 1 ? 1 : -1;
                return 0;
            });
        }

        setTableData(updatedData);
    };

    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setVisibleSection(prev => ({
            ...prev,
            [name]: checked
        }));
    };



    useEffect(() => {
        updateTableData(sortingState);
    }, [sortingState]);

    useEffect(() => {
        setTableData(filteredData);
    }, [filteredData]);

    // --- new: classify rows + stats + toggle filter (same pattern as SiteEmployeeExcelData) ---
    const classifiedList = tableData.map((item) => {
        const status = (item.status || "").toString().trim().toLowerCase();
        const category = status === "pending" ? "pending" : "other";
        return { ...item, _category: category };
    });

    const pendingCount = classifiedList.filter((i) => i._category === "pending").length;
    const otherCount = classifiedList.filter((i) => i._category === "other").length;

    const displayList =
        activeStatFilter === "all"
            ? classifiedList
            : classifiedList.filter((i) => i._category === activeStatFilter);

    const handleStatClick = (filterKey) => {
        setActiveStatFilter((prev) => (prev === filterKey ? "all" : filterKey));
    };

    const hasActiveFilters = activeStatFilter !== "all";

    const exportToExcel = () => {
        console.log(visibleSection, 'visible section')
        const exportData = displayList.map((item, index) => {
            const daysUntilDeadline = item.end_date ? calculateDaysBetweenDates(item.end_date) : "-";
            const isOverdue = item.end_date && new Date(item.end_date) < new Date();
            const isDueSoon = item.end_date && new Date(item.end_date) <= new Date(Date.now() + 3 * 24 * 60 * 60 * 1000);


            let rowData = {
                "S.no.": (currentPage - 1) * itemsPerPage + index + 1
            };


            if (!projectID && visibleSection.project) {
                rowData["Project"] = `${item?.project_pr_code}-${item.project_short_name}`;
            }
            if (visibleSection.AE) {
                rowData["Authority Engineer"] = item.authority_engineer_name || "-";
            }

            if (visibleSection.letterNo) {
                rowData["Letter No."] = item.letter_num || "-";
            }


            if (visibleSection.subject) {
                rowData["Subject"] = item.subject || "-";
            }

            if (visibleSection.tat) {
                rowData["TAT Duration"] = item.tat_duration || "-";
            }

            if (visibleSection.due) {
                rowData["Due Date"] = daysUntilDeadline;
            }

            if (visibleSection.letterDetails) {
                rowData["Coordinator Name"] = item.com_operators_name || "-";
                rowData["Exchange Type"] = item.letterExchange || "-";
                rowData["Letter Type"] = item.lettertype || "-";
                rowData["Other Type Name"] = item.other_type_name || "-";
                rowData["Status"] = item.status || "-";
                rowData["Remarks"] = item.remarks || "-";
                rowData["Time Bound"] = item.is_timebound || "-";
                rowData["Associated Letters"] = item.associated_letters.length > 0 ? "Yes" : "No";
            }

            if (visibleSection.letterFrom) {
                rowData["Letter From"] = item.letter_from || "-";
            }

            if (visibleSection.OtherletterTo) {
                rowData["Other Letter To"] = item.other_letter_to || "-";
            }
            if (visibleSection.OtherletterFrom) {
                rowData["Other Letter From"] = item.other_letter_from || "-";
            }
            if (visibleSection.letterTo) {
                rowData["Letter To"] = item.letter_to || "-";
            }

            if (visibleSection.contractor) {
                rowData["Contractor"] = item.contractorname || "-";
            }

            if (visibleSection.letterDate) {
                rowData["Letter Date"] = item.letter_date ? formattedDateLong(item.letter_date) : "-";
            }

            if (visibleSection.letterAdded) {
                rowData["Letter Added"] = item.created_at ? formattedDateLong(item.created_at) : "-";
            }

            if (visibleSection.deadline) {
                rowData["Deadline"] = item.end_date ? formattedDateLong(item.end_date) : "-";
                rowData["Deadline Status"] = isOverdue ? "Overdue" : isDueSoon ? "Due Soon" : "On Track";
            }

            return rowData;
        });

        // Create a worksheet
        const ws = XLSX.utils.json_to_sheet(exportData);

        // Create a workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Letter Tracking");

        // Generate Excel file and trigger download
        XLSX.writeFile(wb, `Letter_Tracking_${new Date().toISOString().slice(0, 10)}.xlsx`);
    };

    useImperativeHandle(ref, () => ({
        exportToExcel,
    }));

    return (
        <>
            {/* --- new: stats row + filter toggle, same pattern as SiteEmployeeExcelData --- */}
            <div className="stats-minimal-row" style={{ justifyContent: "space-between" }}>
                <div style={{ display: "flex", gap: "20px" }}>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === "all" ? "stat-active" : ""}`}
                        onClick={() => setActiveStatFilter("all")}
                    >
                        <Users size={14} />
                        <span>Total Letters</span>
                        <strong>{classifiedList.length}</strong>
                    </div>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === "pending" ? "stat-active skipped" : ""}`}
                        onClick={() => handleStatClick("pending")}
                    >
                        <XCircle size={14} />
                        <span>Pending</span>
                        <strong>{pendingCount}</strong>
                    </div>
                    <div
                        className={`stat-minimal-item stat-toggle ${activeStatFilter === "other" ? "stat-active achieved" : ""}`}
                        onClick={() => handleStatClick("other")}
                    >
                        <CheckCircle size={14} />
                        <span>Others</span>
                        <strong>{otherCount}</strong>
                    </div>
                </div>

                <div className="filter-bar-top" style={{ width: "auto", gap: "10px" }}>
                    <button className="toggle-filters-btn" onClick={() => setShowFilters(!showFilters)}>
                        <Filter size={14} />
                        <span>{showFilters ? "Hide Filters" : "Show Filters"}</span>
                        {showFilters ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
                    </button>
                </div>
            </div>

            {showFilters && (
                <div className="filter-bar-attractive">
                    <div className="filter-group-attractive" style={{ padding: "0px" }}>
                        <label
                            style={{ marginLeft: 'auto', color: '#2576bc', fontSize: '14px', fontWeight: 500, cursor: 'pointer' }}
                            onClick={() => setShowTableSection(true)}
                        >
                            Customize Table Headings
                        </label>

                        {hasActiveFilters && (
                            <button
                                className="clear-filters-btn"
                                onClick={() => setActiveStatFilter("all")}
                            >
                                <X size={13} />
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            )}

            <Modal show={showTableSection} onHide={() => setShowTableSection(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Customize Table Headings</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div className="table-section-checkbox-field">
                            <input type="checkbox"
                                name="project"
                                checked={visibleSection.project}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="project">Project Name</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input type="checkbox"
                                name="AE"
                                checked={visibleSection.AE}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="AE">Authority Engineer</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="letterNo"
                                checked={visibleSection.letterNo}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="letterNo">Letter No.</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="subject"
                                checked={visibleSection.subject}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="subject">Subject</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="letterFrom"
                                checked={visibleSection.letterFrom}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="letterFrom">Letter From</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="letterTo"
                                checked={visibleSection.letterTo}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="letterTo">Letter To</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="OtherletterFrom"
                                checked={visibleSection.OtherletterFrom}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="OtherletterFrom">Other Letter From</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="OtherletterTo"
                                checked={visibleSection.OtherletterTo}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="OtherletterTo">Other Letter To</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="contractor"
                                checked={visibleSection.contractor}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="contractor">Contractor</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="tat"
                                checked={visibleSection.tat}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="tat">Letter Tat</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="due"
                                checked={visibleSection.due}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="due">Due Date</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="letterDetails"
                                checked={visibleSection.letterDetails}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="letterDetails">Letter Details</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="letterDate"
                                checked={visibleSection.letterDate}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="letterDate">Letter Date</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="letterAdded"
                                checked={visibleSection.letterAdded}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="letterAdded">Letter Add</label>
                        </div>
                        <div className="table-section-checkbox-field">
                            <input
                                type="checkbox"
                                name="deadline"
                                checked={visibleSection.deadline}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor="deadline">Deadline</label>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            <div className="table-css-white-background " style={{ padding: "0px 0px" }}>
                <div className="table-box scroll-container-table">
                    <div>
                        <table className="table-css">
                            <thead className="table-heading" style={{ zIndex: 10 }}>

                                <tr className="custom-table-head-tr">
                                    <th className="table-heading-text text-left-sr">S.no.</th>
                                    {siteRole === "BD" ? (
                                        ""
                                    ) : (
                                        <>
                                            {siteRole !== "ViewAccess" &&
                                                <th className="table-heading-text text-right">Edit Letter</th>
                                            }
                                        </>
                                    )}
                                    {!projectID ? (
                                        visibleSection.project && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('project')}>Project <span>{sortingState.project === 1 ? '▲' : sortingState.project === 2 ? '▼' : ''}</span></th>
                                    ) : (
                                        ""
                                    )}

                                    <th className="table-heading-text text-right">Letter Attachment</th>

                                    {visibleSection.AE && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('AE')}>Authority Engineer<span>{sortingState.AE === 1 ? '▲' : sortingState.AE === 2 ? '▼' : ''}</span></th>}
                                    {visibleSection.letterNo && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('letter')}>Letter No. <span>{sortingState.letter === 1 ? '▲' : sortingState.letter === 2 ? '▼' : ''}</span></th>}
                                    {visibleSection.subject && <th className="table-heading-text text-center">Subject</th>}
                                    {visibleSection.letterFrom && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('letterFrom')}>Letter From <span>{sortingState.letterFrom === 1 ? '▲' : sortingState.letterFrom === 2 ? '▼' : ''}</span></th>}
                                    {visibleSection.OtherletterFrom && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('OtherletterFrom')}>Other Letter From <span>{sortingState.OtherletterFrom === 1 ? '▲' : sortingState.OtherletterFrom === 2 ? '▼' : ''}</span></th>}
                                    {visibleSection.letterTo && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('letterTo')}>Letter To <span>{sortingState.letterTo === 1 ? '▲' : sortingState.letterTo === 2 ? '▼' : ''}</span></th>}
                                    {visibleSection.OtherletterTo && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('OtherletterTo')}>Other Letter To <span>{sortingState.OtherletterTo === 1 ? '▲' : sortingState.OtherletterTo === 2 ? '▼' : ''}</span></th>}
                                    {visibleSection.contractor && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('contractor')}>Contractor <span>{sortingState.contractor === 1 ? '▲' : sortingState.contractor === 2 ? '▼' : ''}</span></th>}
                                    {visibleSection.letterDetails && <th className="table-heading-text text-center hover-heading">Time Bound</th>}
                                    {visibleSection.tat && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('tat')}>TAT Duration <span>{sortingState.tat === 1 ? '▲' : sortingState.tat === 2 ? '▼' : ''}</span></th>}
                                    {visibleSection.due && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('due')}>Due Days <span>{sortingState.due === 1 ? '▲' : sortingState.due === 2 ? '▼' : ''}</span></th>}
                                    {visibleSection.letterDetails && (
                                        <>
                                            <th className="table-heading-text text-center">Coordinator Name</th>
                                            <th className="table-heading-text text-center">Exchange Type</th>
                                            <th className="table-heading-text text-center">Letter Type</th>
                                            <th className="table-heading-text text-center">Other Letter Type</th>
                                            <th className="table-heading-text text-center">Status</th>
                                            <th className="table-heading-text text-center">Remarks</th>
                                            <th className="table-heading-text text-center">Associated Letter</th>
                                        </>
                                    )}
                                    {visibleSection.letterDate && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('letterDate')}>Letter Date <span>{sortingState.letterDate === 1 ? '▲' : sortingState.letterDate === 2 ? '▼' : ''}</span></th>}
                                    {visibleSection.letterAdded && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('letterAdded')}>Letter Add <span>{sortingState.letterAdded === 1 ? '▲' : sortingState.letterAdded === 2 ? '▼' : ''}</span></th>}
                                    {visibleSection.deadline && <th className="table-heading-text text-center hover-heading" onClick={() => cycleSortingState('deadline')}>Deadline <span>{sortingState.deadline === 1 ? '▲' : sortingState.deadline === 2 ? '▼' : ''}</span></th>}

                                    {siteRole === "BD" || siteRole === "ViewAccess" ? (
                                        ""
                                    ) : (
                                        <>
                                            <th className="table-heading-text text-center">Action</th>
                                        </>
                                    )}
                                </tr>
                            </thead>
                            {buffer ? (
                                <div>
                                    <SkeletonLoader animationfirst={true} />
                                    <div className="spinner-bgdatil"></div>


                                </div>
                            ) : //  <div className={`${p_id ? "spinner-smalll" : "spinner-bgdatil"}`}></div>

                                error ? (
                                    <p>Error fetching data: {error.message}</p>
                                ) : displayList.length === 0 ? (
                                    <tbody>
                                        <tr>
                                            <td colSpan={31}>
                                                <div className="empty-state-attractive">
                                                    <div className="empty-state-icon-wrap">
                                                        <Users size={32} />
                                                    </div>
                                                    <h4 className="empty-state-title">No Letters Found</h4>
                                                    <p className="empty-state-subtitle">
                                                        {activeStatFilter !== "all"
                                                            ? "No records match this status. Try a different filter."
                                                            : "Try adjusting your filters."}
                                                    </p>
                                                    {hasActiveFilters && (
                                                        <button
                                                            className="empty-state-clear-btn"
                                                            onClick={() => setActiveStatFilter("all")}
                                                        >
                                                            <X size={13} />
                                                            Clear Filters
                                                        </button>
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                ) : (
                                    <tbody>
                                        {Array.isArray(displayList) &&
                                            displayList.map((i, index) => (
                                                <React.Fragment key={index}>
                                                    <tr
                                                        className={`custom-table-head-td ${i.status === "pending" ? "font-bold" : ""}`}
                                                        style={{ backgroundColor: i.status === "pending" ? "rgba(253, 224, 71, 0.1)" : "", fontWeight: i.status === "pending" ? "bold" : "" }}
                                                        ref={(el) => (rowRefs.current[index] = el)}
                                                    >
                                                        <td className="table-body text-left-sr">
                                                            {(currentPage - 1) * itemsPerPage + index + 1}.
                                                        </td>
                                                        {siteRole === "BD" ? (
                                                            ""
                                                        ) : (
                                                            <>
                                                                {siteRole !== "ViewAccess" &&
                                                                    <td className="table-body ">
                                                                        <UpdateTrackRecordDetails
                                                                            i={i}
                                                                            getProjects={getLetters}
                                                                            projectList={projectList}
                                                                            projectId={projectID}
                                                                            letterType={i.lettertype}
                                                                            workperformedby={i.workperformedby}
                                                                            associatedletters={i.associated_letters}
                                                                            letterData={letterData}
                                                                            LetterTypeOptions={extendedLetterTypeOptions}
                                                                        />

                                                                    </td>
                                                                }
                                                            </>
                                                        )}


                                                        {!projectID ? (
                                                            visibleSection.project && <td className="table-body text-center">
                                                                <div style={{ whiteSpace: "normal" }}>
                                                                    {i?.project_pr_code}-{i.project_short_name}
                                                                </div>
                                                            </td>
                                                        ) : (
                                                            ""
                                                        )}

                                                        <td className="table-body ">
                                                            <div className="flex-row justify-center">

                                                                <DocumentModel letterData={displayList} letterrecord={i.id} title="Letter Attacments" letterType={i.lettertype} project={i.project} projectCode={i.project} />
                                                            </div>
                                                        </td>
                                                        {visibleSection.AE && <td className="table-body form-text-transformation-uppercase">
                                                            <div
                                                                style={{
                                                                    wordBreak: "break-word", // Ensures words break at the container width
                                                                    whiteSpace: "normal", // Allows wrapping to the next line
                                                                }}
                                                            >
                                                                {i.authority_engineer_name}
                                                            </div>
                                                        </td>}
                                                        {visibleSection.letterNo && <td className="table-body form-text-transformation-uppercase">
                                                            <div
                                                                style={{
                                                                    wordBreak: "break-word", // Ensures words break at the container width
                                                                    whiteSpace: "normal", // Allows wrapping to the next line
                                                                }}
                                                            >
                                                                {i.letter_num}
                                                            </div>
                                                        </td>}

                                                        {visibleSection.subject && <td className="table-body text-center">
                                                            <div style={{ width: "120px", whiteSpace: "normal" }}>
                                                                {i.subject ? i.subject : <p className="">-</p>}
                                                            </div>
                                                        </td>}

                                                        {visibleSection.letterFrom && <td className="table-body text-center">
                                                            <div style={{ whiteSpace: "normal" }}>
                                                                {i.letter_from ? i.letter_from : <p className="">-</p>}
                                                            </div>
                                                        </td>}
                                                        {visibleSection.OtherletterFrom && <td className="table-body text-center">
                                                            <div style={{ whiteSpace: "normal" }}>
                                                                {i.other_letter_from ? i.other_letter_from : <p className="">-</p>}
                                                            </div>
                                                        </td>}

                                                        {visibleSection.letterTo && <td className="table-body text-center">
                                                            <div style={{ whiteSpace: "normal" }}>
                                                                {i.letter_to ? i.letter_to : <p className="">-</p>}
                                                            </div>
                                                        </td>}
                                                        {visibleSection.OtherletterTo && <td className="table-body text-center">
                                                            <div style={{ whiteSpace: "normal" }}>
                                                                {i.other_letter_to ? i.other_letter_to : <p className="">-</p>}
                                                            </div>
                                                        </td>}

                                                        {visibleSection.contractor && <td className="table-body text-center">
                                                            <div style={{ whiteSpace: "normal" }}>
                                                                {i.contractorname ? i.contractorname : <p className="">-</p>}
                                                            </div>
                                                        </td>}

                                                        {visibleSection.letterDetails && <td className="table-body text-center">
                                                            <div style={{ whiteSpace: "normal" }}>
                                                                {i.is_timebound === true ? "Yes" : "No"}
                                                            </div>
                                                        </td>}
                                                        {visibleSection.tat && <td className="table-body text-center">
                                                            <div style={{ whiteSpace: "normal" }}>
                                                                {i.tat_duration ? i.tat_duration : <p className="">-</p>}
                                                            </div>
                                                        </td>}
                                                        {visibleSection.due && <td className="table-body text-center">
                                                            <div style={{ whiteSpace: "normal" }}>
                                                                {i.end_date ? calculateDaysBetweenDates(i.end_date) : "-"}
                                                            </div>
                                                        </td>}

                                                        {visibleSection.letterDetails && (
                                                            <>
                                                                <td className="table-body text-center">
                                                                    {i.com_operators_name.map((name, index) => (
                                                                        <tr key={index}>
                                                                            {i.com_operators_name.length > 1 &&
                                                                                <td className="padding-bottom-5px" style={{ paddingRight: "5px" }}>{index + 1}.</td>
                                                                            }
                                                                            <td className="padding-bottom-5px text-start">{name}</td>
                                                                        </tr>
                                                                    ))}
                                                                </td>

                                                                <td className="table-body text-center">
                                                                    <div style={{ whiteSpace: "normal" }}>
                                                                        {i.letterExchange ? i.letterExchange : "-"}
                                                                    </div>
                                                                </td>
                                                                <td className="table-body text-center">
                                                                    <div style={{ whiteSpace: "normal" }}>
                                                                        {i.lettertype}
                                                                    </div>
                                                                </td>
                                                                <td className="table-body text-center">
                                                                    <div style={{ whiteSpace: "normal" }}>
                                                                        {i.other_type_name ? i.other_type_name : "-"}
                                                                    </div>
                                                                </td>
                                                                <td className="table-body text-center">
                                                                    <div style={{ whiteSpace: "normal" }}>
                                                                        {i.status ? i.status : "-"}
                                                                    </div>
                                                                </td>
                                                                <td className="table-body text-center">
                                                                    <div style={{ whiteSpace: "normal" }}>
                                                                        {i.remarks ? (
                                                                            <CustomModel
                                                                                i={i.remarks}
                                                                                usedFor="nestedTable"
                                                                                title="Remarks"
                                                                            />
                                                                        ) : (
                                                                            "-"
                                                                        )}
                                                                    </div>
                                                                </td>
                                                                <td className="table-body text-center ali">
                                                                    <div style={{ whiteSpace: "normal" }}>
                                                                        <AllAssociatedLetters id={i.id} project={i.project} workperformedby={i.workperformedby} lettertype={i.lettertype} />
                                                                    </div>
                                                                </td>
                                                            </>
                                                        )}

                                                        {visibleSection.letterDate && <td className="table-body text-center">{i.letter_date !== null ? formattedDateLong(i.letter_date) : "-"}</td>}
                                                        {visibleSection.letterAdded && <td className="table-body text-center">{i.created_at !== null ? formattedDateLong(i.created_at) : "-"}</td>}
                                                        {visibleSection.deadline && <td
                                                            className="table-body text-start text-center"
                                                            style={{
                                                                color:
                                                                    i.end_date && new Date(i.end_date) < new Date()
                                                                        ? "red"
                                                                        : i.end_date && new Date(i.end_date) <= new Date(Date.now() + 3 * 24 * 60 * 60 * 1000)
                                                                            ? "orange"
                                                                            : "inherit"
                                                            }}
                                                        >
                                                            {i.end_date !== null ? formattedDateLong(i.end_date) : "-"}
                                                        </td>}

                                                        {siteRole === "BD" ? (
                                                            ""
                                                        ) : (
                                                            <>
                                                                <td className="table-body " >
                                                                    <div className="flex-row justify-center" style={{ alignItems: "center" }}>

                                                                        {siteRole === "Admin" || siteRole === "AdminCIPL" ? (
                                                                            <DeleteTrackAndLetterDetails
                                                                                i={i}
                                                                                getLetterDetail={getLetters}
                                                                            />
                                                                        ) :
                                                                            <>
                                                                                {((new Date() - new Date(i.created_at)) / (1000 * 60 * 60) < 24) && siteRole === "SiteManagement" ?
                                                                                    <DeleteTrackAndLetterDetails
                                                                                        i={i}
                                                                                        getLetterDetail={getLetters}
                                                                                    /> : <span className="required">Access Denied</span>
                                                                                }

                                                                            </>

                                                                        }
                                                                    </div>
                                                                </td>
                                                            </>
                                                        )}
                                                    </tr>
                                                </React.Fragment>
                                            ))}
                                    </tbody>
                                )}
                        </table>
                    </div>
                </div>
            </div>
        </>
    );

});

export default SortingTable;

